// import AddMusicToSheet from "./AddMusicToSheet";
import Base from './Base';
// import ExitConfirm from "./ExitConfirm";
// import ImportMusicSheet from "./ImportMusicSheet";
// import PluginSubscription from "./PluginSubscription";
// import Reconfirm from "./Reconfirm";
// import SearchLyric from "./SearchLyric";
// import SelectOne from "./SelectOne";
import SimpleInputWithState from './SimpleInputWithState';
import Reconfirm from './Reconfirm';
import SelectOne from './SelectOne';
import SearchLyric from './SearchLyric';
import AddNewSheet from './AddNewSheet';
// import Sparkles from "./Sparkles";
// import Update from "./Update";
// import WatchLocalDir from "./WatchLocalDir";

export default {
    Base,
    // ExitConfirm,
    AddNewSheet,
    // AddMusicToSheet,
    // Sparkles,
    SimpleInputWithState,
    Reconfirm,
    // Update,
    // WatchLocalDir,
    SelectOne,
    // PluginSubscription,
    SearchLyric,
    // ImportMusicSheet
}
